(function () {
  'use strict';

  function money(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function parseConfig(section) {
    var node = section.querySelector('[data-rpb-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function initBuilder(section) {
    if (!section || section.dataset.rouxPbReady === 'true') return;
    section.dataset.rouxPbReady = 'true';

    var config = parseConfig(section);
    if (!config) return;

    var variants = Array.isArray(config.variants) ? config.variants : [];
    var selectedVariant = variants.find(function (variant) { return variant.available; }) || variants[0] || null;
    var selectedQuantity = 1;
    var selectedDiscountCents = 0;
    var selectedPlan = 1;

    var slides = Array.from(section.querySelectorAll('[data-rpb-slide]'));
    var thumbs = Array.from(section.querySelectorAll('[data-rpb-thumb]'));
    var currentSlide = 0;
    var countNode = section.querySelector('[data-rpb-count]');

    var offerWrap = section.querySelector('[data-rpb-offers]');
    var offerButtons = Array.from(section.querySelectorAll('[data-rpb-offer]'));
    var addButton = section.querySelector('[data-rpb-add]');
    var addLabel = section.querySelector('[data-rpb-add-label]');
    var statusNode = section.querySelector('[data-rpb-status]');
    var basePriceNode = section.querySelector('[data-rpb-base-price]');
    var compareNode = section.querySelector('[data-rpb-compare-price]');
    var inventoryNode = section.querySelector('[data-rpb-inventory]');
    var inventoryText = section.querySelector('[data-rpb-inventory-text]');
    var sticky = section.querySelector('[data-rpb-sticky]');
    var stickyButton = section.querySelector('[data-rpb-sticky-add]');
    var stickyPlan = section.querySelector('[data-rpb-sticky-plan]');
    var stickyPrice = section.querySelector('[data-rpb-sticky-price]');
    var buyZone = section.querySelector('[data-rpb-buy-zone]');
    var whatsapp = section.querySelector('[data-rpb-whatsapp]');
    var optionInputs = Array.from(section.querySelectorAll('[data-rpb-option]'));

    function currentBasePrice() {
      return selectedVariant ? Number(selectedVariant.price || 0) : 0;
    }

    function selectedTotal() {
      return Math.max(0, (currentBasePrice() * selectedQuantity) - selectedDiscountCents);
    }

    function showSlide(index) {
      if (!slides.length) return;

      currentSlide = (index + slides.length) % slides.length;

      slides.forEach(function (slide, idx) {
        var active = idx === currentSlide;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');

        if (!active) {
          slide.querySelectorAll('video').forEach(function (video) {
            try { video.pause(); } catch (e) {}
          });
        }
      });

      thumbs.forEach(function (thumb, idx) {
        var active = idx === currentSlide;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active && typeof thumb.scrollIntoView === 'function') {
          thumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
        }
      });

      if (countNode) {
        countNode.textContent = (currentSlide + 1) + ' / ' + slides.length;
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showSlide(Number(thumb.dataset.index || 0));
      });
    });

    var prev = section.querySelector('[data-rpb-prev]');
    var next = section.querySelector('[data-rpb-next]');

    if (prev) prev.addEventListener('click', function () { showSlide(currentSlide - 1); });
    if (next) next.addEventListener('click', function () { showSlide(currentSlide + 1); });

    var mainMedia = section.querySelector('.roux-pb__main-media');
    var touchStartX = null;

    if (mainMedia) {
      mainMedia.addEventListener('touchstart', function (event) {
        if (!event.touches || !event.touches.length) return;
        touchStartX = event.touches[0].clientX;
      }, { passive: true });

      mainMedia.addEventListener('touchend', function (event) {
        if (touchStartX === null || !event.changedTouches || !event.changedTouches.length) return;
        var diff = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(diff) < 42) return;
        showSlide(currentSlide + (diff < 0 ? 1 : -1));
      }, { passive: true });
    }

    function showVariantMedia() {
      if (!selectedVariant || !selectedVariant.featuredMediaId) return;
      var id = String(selectedVariant.featuredMediaId);
      var idx = slides.findIndex(function (slide) {
        return String(slide.dataset.mediaId || '') === id;
      });
      if (idx >= 0) showSlide(idx);
    }

    function findVariantFromOptions() {
      if (!optionInputs.length || !variants.length) return selectedVariant;

      var selected = optionInputs.map(function (input) { return input.value; });
      return variants.find(function (variant) {
        return Array.isArray(variant.options) &&
          variant.options.length === selected.length &&
          variant.options.every(function (value, index) { return value === selected[index]; });
      }) || null;
    }

    function updateVariant() {
      if (optionInputs.length) {
        selectedVariant = findVariantFromOptions();
      }

      if (basePriceNode) {
        basePriceNode.textContent = money(currentBasePrice(), config.currency);
      }

      if (compareNode) {
        var compare = selectedVariant ? Number(selectedVariant.compareAtPrice || 0) : 0;
        if (compare > currentBasePrice()) {
          compareNode.textContent = money(compare, config.currency);
          compareNode.classList.remove('is-hidden');
        } else {
          compareNode.textContent = '';
          compareNode.classList.add('is-hidden');
        }
      }

      showVariantMedia();
      updateOffers();
      updateInventory();
      updateAvailability();
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    function updateOffers() {
      var base = currentBasePrice();

      offerButtons.forEach(function (button) {
        var qty = Number(button.dataset.quantity || 1);
        var discount = Number(button.dataset.discountCents || 0);
        var total = Math.max(0, (base * qty) - discount);
        var priceNode = button.querySelector('[data-rpb-offer-price]');
        var perUnit = button.querySelector('[data-rpb-per-unit]');

        if (priceNode) priceNode.textContent = money(total, config.currency);
        if (perUnit) perUnit.textContent = money(total / qty, config.currency) + ' each';
      });

      updatePurchaseUI();
    }

    function selectOffer(button) {
      if (!button) return;

      selectedPlan = Number(button.dataset.plan || 1);
      selectedQuantity = Number(button.dataset.quantity || 1);
      selectedDiscountCents = Number(button.dataset.discountCents || 0);

      offerButtons.forEach(function (offer) {
        var active = offer === button;
        offer.classList.toggle('is-selected', active);
        offer.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      updatePurchaseUI();
    }

    offerButtons.forEach(function (button) {
      button.addEventListener('click', function () { selectOffer(button); });
      button.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault();
        var idx = offerButtons.indexOf(button);
        var nextIndex = event.key === 'ArrowDown'
          ? (idx + 1) % offerButtons.length
          : (idx - 1 + offerButtons.length) % offerButtons.length;
        offerButtons[nextIndex].focus();
        selectOffer(offerButtons[nextIndex]);
      });
    });

    function updateAvailability() {
      var available = Boolean(selectedVariant && selectedVariant.available);
      if (addButton) addButton.disabled = !available;
      if (stickyButton) stickyButton.disabled = !available;
      updatePurchaseUI();
    }

    function updatePurchaseUI() {
      var total = selectedTotal();
      var available = Boolean(selectedVariant && selectedVariant.available);
      var prefix = addButton ? (addButton.dataset.prefix || 'ADD') : 'ADD';

      if (addLabel) {
        addLabel.textContent = available
          ? prefix + ' ' + selectedQuantity + ' TO CART • ' + money(total, config.currency)
          : 'SOLD OUT';
      }

      if (stickyPlan) {
        stickyPlan.textContent = 'BUY ' + selectedQuantity + ' SELECTED';
      }

      if (stickyPrice) {
        stickyPrice.textContent = money(total, config.currency);
      }

      if (whatsapp) {
        var number = whatsapp.dataset.number || '';
        var planMessage =
          selectedPlan === 3 ? (whatsapp.dataset.message3 || '') :
          selectedPlan === 2 ? (whatsapp.dataset.message2 || '') :
          (whatsapp.dataset.message1 || '');

        var message = "Hello, I'm interested in the ROUX Hair Texture Powder - " + planMessage;
        whatsapp.href = 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);
      }
    }

    function updateInventory() {
      if (!inventoryNode || !inventoryText || !selectedVariant) return;

      var management = selectedVariant.inventoryManagement;
      var quantity = Number(selectedVariant.inventoryQuantity || 0);
      var threshold = Number(inventoryNode.dataset.threshold || 10);

      var shouldShow = Boolean(management) && quantity > 0 && quantity <= threshold;
      inventoryNode.classList.toggle('is-hidden', !shouldShow);

      if (shouldShow) {
        var template = inventoryText.textContent || 'Only {count} left in stock';
        inventoryText.textContent = template.replace('{count}', String(quantity));
      }
    }

    function setStatus(message, isError) {
      if (!statusNode) return;
      statusNode.textContent = message || '';
      statusNode.style.color = isError ? 'var(--rpb-danger)' : 'var(--rpb-success)';
    }

    function setLoading(loading) {
      if (addButton) {
        addButton.disabled = loading || !(selectedVariant && selectedVariant.available);
        addButton.classList.toggle('is-loading', loading);
      }
      if (stickyButton) {
        stickyButton.disabled = loading || !(selectedVariant && selectedVariant.available);
      }
      if (addLabel && loading) {
        addLabel.textContent = 'ADDING...';
      }
      if (stickyButton && loading) {
        stickyButton.textContent = 'ADDING...';
      }
      if (!loading && stickyButton) {
        stickyButton.textContent = 'ADD TO CART';
      }
      if (!loading) updatePurchaseUI();
    }

    function updateNativeCartBubble(sections) {
      if (!sections) return;

      var html = sections['cart-icon-bubble'];
      if (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var nextBubble = doc.querySelector('#cart-icon-bubble');
        var currentBubble = document.querySelector('#cart-icon-bubble');
        if (nextBubble && currentBubble) currentBubble.replaceWith(nextBubble);
      }
    }

    async function addToCart() {
      if (!selectedVariant || !selectedVariant.available) return;

      setStatus('');
      setLoading(true);

      try {
        var root = config.routesRoot || '/';
        var response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: Number(selectedVariant.id),
              quantity: selectedQuantity
            }],
            sections: ['cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });

        var data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Unable to add this item.');
        }

        updateNativeCartBubble(data.sections);
        setStatus('Added to cart.');

        document.dispatchEvent(new CustomEvent('roux:cart:refresh', {
          detail: {
            open: true,
            source: 'roux-product-builder',
            quantity: selectedQuantity,
            variantId: Number(selectedVariant.id)
          }
        }));

        document.dispatchEvent(new CustomEvent('product:added', {
          detail: { source: 'roux-product-builder', item: data }
        }));

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));

        var customCartButton = document.querySelector('[data-roux-cart-open]');
        if (customCartButton && !document.body.classList.contains('roux-cart-open')) {
          window.setTimeout(function () {
            try { customCartButton.click(); } catch (e) {}
          }, 120);
        }

        window.setTimeout(function () { setStatus(''); }, 1800);
      } catch (error) {
        setStatus(error.message || 'Unable to add this item. Please try again.', true);
      } finally {
        setLoading(false);
      }
    }

    if (addButton) addButton.addEventListener('click', addToCart);
    if (stickyButton) stickyButton.addEventListener('click', addToCart);

    var reviewLinks = Array.from(section.querySelectorAll('[data-rpb-review-link]'));
    reviewLinks.forEach(function (button) {
      button.addEventListener('click', function () {
        var selector = config.reviewTarget || '.jdgm-widget';
        var target = null;

        try { target = document.querySelector(selector); } catch (e) {}

        if (!target) {
          target = document.querySelector('.jdgm-widget, [data-reviews], #shopify-product-reviews, .loox-reviews-default');
        }

        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    var accordions = Array.from(section.querySelectorAll('[data-rpb-accordion]'));

    function openAccordion(item) {
      var toggle = item.querySelector('[data-rpb-accordion-toggle]');
      var panel = item.querySelector('[data-rpb-accordion-panel]');
      if (!toggle || !panel) return;

      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      panel.classList.add('is-open');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }

    function closeAccordion(item) {
      var toggle = item.querySelector('[data-rpb-accordion-toggle]');
      var panel = item.querySelector('[data-rpb-accordion-panel]');
      if (!toggle || !panel) return;

      item.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      panel.classList.remove('is-open');
      panel.style.maxHeight = '0px';
    }

    accordions.forEach(function (item) {
      var toggle = item.querySelector('[data-rpb-accordion-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        accordions.forEach(function (other) {
          if (other !== item) closeAccordion(other);
        });

        if (isOpen) closeAccordion(item);
        else openAccordion(item);
      });

      closeAccordion(item);
    });

    window.addEventListener('resize', function () {
      accordions.forEach(function (item) {
        if (!item.classList.contains('is-open')) return;
        var panel = item.querySelector('[data-rpb-accordion-panel]');
        if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
      });
    }, { passive: true });

    var zoomModal = section.querySelector('[data-rpb-zoom-modal]');
    var zoomImage = section.querySelector('[data-rpb-zoom-image]');
    var zoomClose = section.querySelector('[data-rpb-zoom-close]');

    function openZoom(src) {
      if (!zoomModal || !zoomImage || !src) return;
      zoomImage.src = src;
      zoomModal.classList.add('is-open');
      zoomModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('roux-pb-zoom-open');
      if (zoomClose) zoomClose.focus();
    }

    function closeZoom() {
      if (!zoomModal || !zoomImage) return;
      zoomModal.classList.remove('is-open');
      zoomModal.setAttribute('aria-hidden', 'true');
      zoomImage.removeAttribute('src');
      document.body.classList.remove('roux-pb-zoom-open');
    }

    section.querySelectorAll('[data-rpb-zoom]').forEach(function (button) {
      button.addEventListener('click', function () {
        openZoom(button.dataset.zoomSrc || '');
      });
    });

    if (zoomClose) zoomClose.addEventListener('click', closeZoom);

    if (zoomModal) {
      zoomModal.addEventListener('click', function (event) {
        if (event.target === zoomModal || event.target.classList.contains('roux-pb__zoom-stage')) {
          closeZoom();
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && zoomModal && zoomModal.classList.contains('is-open')) {
        closeZoom();
      }
    });

    function cartOrMenuOpen() {
      return document.body.classList.contains('roux-cart-open') ||
        document.body.classList.contains('menu-open') ||
        document.body.classList.contains('overflow-hidden') ||
        Boolean(document.querySelector('[data-roux-cart-drawer].is-open, .roux-cart-drawer.is-open'));
    }

    function updateSticky() {
      if (!sticky || !buyZone) return;

      var rect = buyZone.getBoundingClientRect();
      var passed = rect.bottom < 0;
      var shouldShow = passed && !cartOrMenuOpen();

      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    if (sticky && buyZone) {
      var stickyObserver = new IntersectionObserver(function () {
        updateSticky();
      }, { threshold: 0 });

      stickyObserver.observe(buyZone);

      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky, { passive: true });

      var bodyObserver = new MutationObserver(updateSticky);
      bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

      document.addEventListener('roux:cart:refresh', updateSticky);
      document.addEventListener('cart:updated', updateSticky);

      updateSticky();
    }

    var defaultPlan = offerWrap ? Number(offerWrap.dataset.defaultPlan || 1) : 1;
    var defaultOffer = offerButtons.find(function (button) {
      return Number(button.dataset.plan || 0) === defaultPlan;
    }) || offerButtons[0];

    if (defaultOffer) selectOffer(defaultOffer);
    updateVariant();
    showSlide(0);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-roux-product-builder]').forEach(initBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
